import { httpBatchLink } from "@trpc/client";
import superjson from "superjson";
import { getImpersonationToken } from "./impersonation.js";
import { trpc } from "./trpc.js";

/**
 * Factory do cliente tRPC.
 * Inclui credentials: "include" para que o cookie de sessão seja enviado automaticamente.
 */
export function createTrpcClient() {
  return trpc.createClient({
    links: [
      httpBatchLink({
        url: "/trpc",
        transformer: superjson,
        // F-impersonate-tab — sessão "Entrar como" POR ABA: token do
        // sessionStorage vai como Bearer e vence o cookie no servidor.
        headers() {
          const token = getImpersonationToken();
          return token ? { authorization: `Bearer ${token}` } : {};
        },
        // Erro de TRANSPORTE (servidor offline, rede caiu, reload do dev) lança
        // TypeError "Failed to fetch" — críptico. Trocamos por mensagem clara;
        // o tRPC propaga este `.message` para os onError (modais/banners do app).
        fetch: async (url, options) => {
          try {
            return await fetch(url, { ...options, credentials: "include" });
          } catch {
            throw new Error(
              "Não foi possível conectar ao servidor. Verifique sua conexão e tente novamente.",
            );
          }
        },
      }),
    ],
  });
}
